module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. All rights reserved.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. All rights reserved.',
  'account.footer.exchange': '交易所',
  'account.footer.home': '主页',
  'balances.filteredByAsset': '筛选资产',
  'balances.hideZeroBalance': '隐藏为0的资产',
  'balances.myBalances': '我的资产',
  'blocked.country.list':
    "United States of America, Albania, Bosnia and Herzegovina, Belarus, Congo (DRC), Côte d'Ivoire, Crimea, Cuba, Iraq, Iran, North Korea, Liberia, Macedonia, Myanmar, Serbia, Sudan, Syria, Zimbabwe.",
  'common.cancel': '取消',
  'common.close': '关闭',
  'common.confirm': '确认 ',
  'common.connect': '连接',
  'common.continue': '继续/下一步',
  'common.errorOccured': 'error occured',
  'common.goBack': '返回',
  'common.googleUnlock': 'Google云端硬盘',
  'common.keystoreFile': 'Keystore 文件',
  'common.ledgerDevice': 'Ledger 设备',
  'common.loading': '加载中',
  'common.mnemonicPhrase': '恢复助记词',
  'common.networkError': '网络错误',
  'common.or': '或',
  'common.password': '密码',
  'common.placeOrder': '下单',
  'common.pleaseCheckVisitWebsite': '请确认您正在浏览币安链官方网站：',
  'common.previous': '上一步',
  'common.privateKey': '私钥',
  'common.systemError': '系统错误',
  'common.trezorDevice': 'Trezor 设备',
  'common.viewMyPrivateKey': '查看我的私钥',
  'common.viewOnly': 'View Only',
  'common.walletConnect': '手机钱包',
  'common.yes': '是',
  'common.warning': '警告',
  'create.backupKeystore.backupYour': '请备份您的',
  'create.backupKeystore.cannotRecoveredIt': '一旦丢失，无法恢复。',
  'create.backupKeystore.createBackupFile': '请做好备份',
  'create.backupKeystore.downloadKeystoreFile': '下载Keystore文件(UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': '获取我的私钥',
  'create.backupKeystore.keystoreFile': 'Keystore文件',
  'create.backupKeystore.needFirstDownload': '您必须先下载Keystore文件',
  'create.backupKeystore.notShareFile':
    '请不要对外分享私钥，也不要在其他网站上使用私钥, 否则您的资金将有被盗风险。',
  'create.backupMnemonic.note': '把下面的助记词备份在纸上，并将其保存在某个秘密和安全的地方。',
  'create.backupMnemonic.title': '请备份助记词',
  'create.backupText': '把下面的助记词备份在纸上，并将其保存在某个秘密和安全的地方。',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'Keystore 文件 + 密码',
  'create.chooseKSOrMnemonic.keystoreFile': 'Keystore 文件',
  'create.chooseKSOrMnemonic.recommendedUSBDrive': '建议备份在USB内',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper': '建议备份在纸上或USB内',
  'create.chooseKSOrMnemonic.title': '请选择您创建钱包的方式？',
  'create.chooseKSOrMnemonic.unlockExistWallet': '解锁钱包',
  'create.chooseKSOrMnemonic.useKeystoreFile': '使用【Keystore文件 + 密码】解锁你的钱包',
  'create.chooseKSOrMnemonic.useMnemonicPhrase': '使用24个单词组成的助记词来解锁您的钱包',
  'create.confirmNote': '请确认已经备份好助记词?',
  'create.createNewWallet': '创建新钱包',
  'create.doubleConfirmMnemonic.note': '请按顺序选择您的助记词，确保您的备份是正确的。',
  'create.doubleConfirmMnemonic.title': '选择二次访问',
  'create.doubleConfirmMnemonic.tryAgain': '助记词顺序不正确，请校对',
  'create.downloadKeyStoreFile': '下载Keystore文件',
  'create.enterPassword': '输入密码',
  'create.google.createWallet': '创建钱包',
  'create.google.createdSuccessfully': '钱包创建完成',
  'create.google.creationFailure': '钱包创建失败',
  'create.google.tryAgain': '再试一次',
  'create.google.walletName': '钱包的名字',
  'create.googledrive.rePassErr': '输入的密码不匹配',
  'create.keystoreFileAndPassword': '创建Keystore文件 + 密码',
  'create.pick.useGoogleDrive.description': '用Google云端硬盘创建一个新的钱包',
  'create.pick.useGoogleDrive.title': '使用Google云端硬盘',
  'create.pick.useLocalKeystore.description': '创建一个您的设备上保存的钱包',
  'create.pick.useLocalKeystore.title': '使用Keystore文件',
  'create.pleaseCheck': '请确认您正在浏览币安链官方网站：',
  'create.reEnterPassword': '重新输入密码',
  'create.stepTwo.desc': '我们即将展示您的助记词，请确保没有其他人在看您的屏幕。',
  'create.success.desc1': '开始使用币安钱包和',
  'create.success.desc2': '去中心化交易所吧！',
  'create.success.title': '你已经准备好了！',
  'create.success.unlockWallet': '解锁钱包',
  'create.tutorial.next': '下一步',
  'create.tutorial.skip': '跳过教程（不推荐）',
  'create.tutorial.step1.desc1':
    '币安链致力于为您提供最优质、最安全的使用体验。要做到这一点，我们希望您花一分钟的时间来了解去中心化的钱包是如何工作的，并学会采取相应措施保护您的账号和资产安全。详情请查阅我们的服务条款。',
  'create.tutorial.step1.title': '我们的建议',
  'create.tutorial.step2.desc1':
    '请务必保管好您的钱包。一旦丢失，包括币安在内的任何人都没办法帮您恢复。',
  'create.tutorial.step2.desc2': '您有三种不同的方法在币安链上创建钱包，每种方法都可以访问钱包。',
  'create.tutorial.step2.title': '保管好您的钱包',
  'create.tutorial.step3.desc1':
    'Keystore文件是保存私钥的加密文件，您可以为自己的Keystore文件设置密码保护。当您使用【Keystore 文件 + 密码】这种方式来访问钱包时，需要两者同时使用才能生效。丢失其中一个，您将无法找回您的资产，请务必保管好它们。',
  'create.tutorial.step3.title': 'Keystore文件 + 密码',
  'create.tutorial.step4.desc1':
    '助记词是由24个单词组成的，是开启你钱包的第二种方式，请备份并保管好您的助记词。请不要对外分享您的助记词，也不要在其他网站上使用助记词，否则您的资产将有被盗风险。',
  'create.tutorial.step4.title': '助记词',
  'create.tutorial.step5.desc1': '私钥是助记词的另一种展现形式。',
  'create.tutorial.step5.desc2':
    '币安链要求所有的用户使用Keystore文件 + 密码的方式，同时请对助记词和私钥做好备份，以作为备用的方式访问钱包。',
  'create.tutorial.step5.title': '私钥',
  'create.tutorial.title': '钱包创建教程',
  'create.tutorial.understand': '我已知晓',
  'create.understandCheckbox':
    '我已知晓币安无法恢复或者重置我的密码或者Keystore文件，我已备份并保存好Keystore 文件/密码，完成所有钱包创建步骤，并同意所有',
  'create.understandCheckbox.terms': '条款。',
  'create.unlockExistWallet': '解锁钱包',
  'create.yourKeyStore': '你的Keystore',
  'editWallet.remove': '移除',
  'editWallet.remove.desc1': '请确认钱包里没有钱',
  'editWallet.remove.desc2': '因为没有恢复钱包的方法',
  'editWallet.remove.removeButton': '是的，删除这个钱包',
  'editWallet.remove.title': '是否真的要删除这个钱包',
  'editWallet.rename': '重命名',
  'editWallet.rename.duplicateName': '钱包名字已存在',
  'editWallet.rename.errMsg': '名字不能为空',
  'editWallet.rename.title': '钱包名字',
  'editWallet.title': '钱包名字',
  'editWallet.createWallet': '创建钱包',
  'editWallet.unlockWallet': '解锁钱包',
  'exchange.BTCValue': 'BTC估值',
  'exchange.amount': '数量',
  'exchange.asset': '币种',
  'exchange.availableBalance': '可用资产',
  'exchange.blockHeight': '区块高度',
  'exchange.buy': '买入',
  'exchange.calendar.clear': '清除',
  'exchange.calendar.ok': '确认',
  'exchange.calendar.today': '今天',
  'exchange.chartbox.depth': '深度图',
  'exchange.coin': '币种',
  'exchange.date': '时间',
  'exchange.estimatedValue': '估值',
  'exchange.filled': '成交率',
  'exchange.from': '发起地址',
  'exchange.frozen': '冻结',
  'exchange.hideAllCanceled': '隐藏撤销订单',
  'exchange.hideOtherPairs': '隐藏其他交易对',
  'exchange.inOrder': '下单冻结',
  'exchange.index.books': 'Books',
  'exchange.index.chart': 'Chart',
  'exchange.max': '最大',
  'exchange.min': '最小交易单位：',
  'exchange.name': '名称',
  'exchange.notional': '总额',
  'exchange.oneDay': '当日',
  'exchange.oneMonth': '1个月',
  'exchange.oneWeek': '1周',
  'exchange.pair': '市场',
  'exchange.placeOrder.bestAsk': '最优卖价',
  'exchange.placeOrder.bestBid': '最优买价',
  'exchange.placeOrder.limitOrder': '限价单',
  'exchange.placeOrder.noEnoughBalance': '没有足够的余额',
  'exchange.placeOrder.orderError': '下单异常',
  'exchange.placeOrder.orderPriceHigher': '您的订单价格高出市场最新价格2％，请谨慎下单。',
  'exchange.placeOrder.orderPriceLow': '您的订单价格低于市场最新价格2％，请谨慎下单。',
  'exchange.placeOrder.pleaseInputCorrectAmount': '请输入正确的数量',
  'exchange.placeOrder.pleaseInputCorrectPrice': '请输入正确的价格',
  'exchange.placeOrder.roundSizeErrorMsg': '你只能 {side} {baseAsset} 以 {lotSize} 的整数倍',
  'exchange.placeOrder.successNotifyMsg': '您已成功创建 {quantity} {quoteAsset} 限价 {side} 单',
  'exchange.placeOrder.successNotifyTitle': '限价{side}单创建成功',
  'exchange.pleaseSelectDate': '请选择时间',
  'exchange.pleaseUnlockWallet.btn': '解锁钱包',
  'exchange.pleaseUnlockWallet.createNewWallet': '请先创建一个新钱包',
  'exchange.pleaseUnlockWallet.desc': '抱歉，请先解锁您的钱包。',
  'exchange.pleaseUnlockWallet.noWallet': '没有钱包？',
  'exchange.price': '价格',
  'exchange.search': '查询',
  'exchange.sell': '卖出',
  'exchange.side': '方向',
  'exchange.status': '状态',
  'exchange.symbolPriceInfo.high': '最高价',
  'exchange.symbolPriceInfo.lastPrice': '最新价',
  'exchange.symbolPriceInfo.low': '最低价',
  'exchange.symbolPriceInfo.twentyFourHChange': '24h涨跌',
  'exchange.symbolPriceInfo.twentyFourHHigh': '24h最高价',
  'exchange.symbolPriceInfo.twentyFourHLow': '24h最低价',
  'exchange.symbolPriceInfo.twentyFourHVolume': '24h成交量',
  'exchange.symbolPriceInfo.vol': '成交量',
  'exchange.threeMonths': '3个月',
  'exchange.time.from': '时间',
  'exchange.to': '收款地址',
  'exchange.total': '总额',
  'exchange.totalBalance': '总额',
  'exchange.tradingHistory.time': '时间',
  'exchange.tradingHistory.title': '最新成交',
  'exchange.tradingPair.change': '涨跌',
  'exchange.tradingPair.pair': '市场',
  'exchange.tradingPair.price': '价格',
  'exchange.tradingPair.search': '搜索',
  'exchange.tradingPair.volume': '成交量',
  'exchange.txFee': '手续费',
  'exchange.txHash': 'TxHash',
  'exchange.type': '类型',
  'exchange.value': '数量',
  'fees.fee': '手续费',
  'fees.height': '区块高度',
  'fees.note': '备注',
  'footer.terms': '条款服务',
  'footer.privacy': '隐私说明',
  'googledrive.create.nameExist': '名字已存在',
  'header.balances': '资产',
  'header.createWallet': '创建钱包',
  'header.exchange': '交易所',
  'header.explorer': '区块链浏览器',
  'header.faq': 'Docs / FAQ',
  'header.feeHistory': '手续费历史',
  'header.forums': '论坛',
  'header.mainnet': '主网',
  'header.openOrders': '当前委托',
  'header.orderHistory': '委托历史',
  'header.orders': '委托管理',
  'header.testnet': '测试网',
  'header.tradeHistory': '历史成交',
  'header.transactions': '交易记录',
  'header.unlockWallet': '解锁钱包',
  'header.user.changeWallet': '切换钱包',
  'header.user.closeWallet': '关闭钱包',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': '复制地址',
  'header.user.copySuccess': '复制成功!',
  'header.user.createNewWallet': '创建新钱包',
  'header.user.exportKeystoreFile': '导出Keystore文件',
  'header.user.goToExplorer': '前往浏览器',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ledger ',
  'header.user.trezor': 'Trezor 设备',
  'header.user.wallet': '钱包',
  'header.user.walletConnect': 'WalletConnect ',
  'header.youWantCloseWallet': '你确定要关闭钱包吗?',
  'home.aboutPage.desc1.line1': '币安链是币安最初开发的区块链。',
  'home.aboutPage.desc1.line2': '先进、安全、高效。',
  'home.aboutPage.desc2.line1': '币安去中心化交易所采用分布式订单匹配引擎，',
  'home.aboutPage.desc2.line2': '以币安链的核心技术为驱动。',
  'home.aboutPage.desc3.line1': '币安去中心化交易所是一个先进的、安全的数字资产发行和交易平台，',
  'home.aboutPage.desc3.line2': '私钥自有, 交易您最喜欢的资产从未如此安全。',
  'home.aboutPage.title': '关于币安去中心化交易所',
  'home.binanceDex': '币安去中心化交易平台',
  'home.processPage.aboutBalance': '关于币安去中心化交易所',
  'home.processPage.create': '创建',
  'home.processPage.createDesc': '创建币安链上钱包是第一步',
  'home.processPage.createWallet': '创建新钱包',
  'home.processPage.getStart': '开始使用币安去中心化交易所',
  'home.processPage.go': '前往',
  'home.processPage.placeOrders': '下单',
  'home.processPage.placeOrdersDesc': '使用Web钱包或API发送和取消订单。',
  'home.processPage.transferAssets': '转账',
  'home.processPage.transferAssetsDesc':
    '使用币安链地址(可由支持币安链的任何钱包生成)，您可以交易存储在该地址上的BNB或其他资产。',
  'home.processPage.unlock': '解锁',
  'home.processPage.unlockDesc': '四种方式解锁你的钱包',
  'home.processPage.unlockMode1': 'WalletConnect',
  'home.processPage.unlockMode2': 'Ledger',
  'home.processPage.unlockMode3': 'Keystore 文件+密码',
  'home.processPage.unlockMode4': '助记词',
  'home.processPage.unlockWallet': '解锁钱包',
  'home.startPage.createWallet': '创建钱包',
  'home.startPage.desc1': '安全高效的去中心化数字资产交易平台',
  'home.startPage.desc2': '引领加密货币交易新潮流',
  'home.startPage.getTestBNB': '获取测试BNB',
  'home.startPage.startTrading': '开启交易',
  'home.whyPage.community': '社区自治',
  'home.whyPage.communityDesc': '币安去中心化交易所由在线治理和开源技术提供支持。',
  'home.whyPage.decentralized': '去中心化',
  'home.whyPage.decentralizedDesc': '钱包到钱包的交易，没有第三方和中心化的介入。',
  'home.whyPage.getStarted': '开始使用',
  'home.whyPage.lowTradingFees': '低交易手续费',
  'home.whyPage.lowTradingFeesDesc': '充值、提现、下单免费。---BNB持有者可以享受更低的费用。',
  'home.whyPage.safeAndSecure': '安全可靠',
  'home.whyPage.safeAndSecureDesc': '资产存储在区块链地址上，只有您的私钥可以打开它。',
  'home.whyPage.title': '为什么选择币安去中心化交易所',
  'home.whyPage.userFriendly': '人性化体验',
  'home.whyPage.userFriendlyDesc': '无需充值或者提现，创建/解锁钱包，就可以交易。',
  'inputPassword.passwordRule': '您的密码必须符合以下要求',
  'inputPassword.passwordRule1': '至少8位字符',
  'inputPassword.passwordRule2': '至少含有一个大写字母，特殊字符或者数字',
  'inputPassword.setANewPassword': '设置一个新密码',
  'landing.connectWallet': '关联钱包',
  'landing.createWallet': '创建钱包',
  'landing.desc1': '币安去中心化交易平台',
  'landing.desc2': '安全高效的去中心化数字资产交易平台\n引领加密货币交易新潮流',
  'landing.footer.fee': '手续费',
  'landing.footer.terms': '服务条款',
  'landing.footer.privacy': '隐私说明',
  'landing.how.connect': '连接',
  'landing.how.connect.desc':
    '访问Binance DEX比您想象的要容易。从连接选项中选择, 然后单击连接按钮。就可以开始了',
  'landing.how.create': '创建',
  'landing.how.create.desc': 'Binance DEX让您可以自由选择，从便利的密钥库到超安全的硬件钱包选项。',
  'landing.how.step': '步骤',
  'landing.how.title': '怎么使用',
  'landing.how.trade': '交易',
  'landing.how.trade.desc':
    '我们的目标是使交易与Binance.com无缝且无法区分。 为此，我们优化了最佳功能，以便您喜欢的所有内容也都在Binance DEX上。',
  'landing.markets': '市场',
  'landing.markets.24HChange': '24小时涨跌',
  'landing.markets.24HVolume': '24小时成交量',
  'landing.markets.lastPrice': '价格',
  'landing.markets.pair': '市场',
  'landing.markets.searchPlaceholder': '查询币种名称',
  'landing.menu.balances': '余额',
  'landing.menu.changeWallet': '切换钱包',
  'landing.menu.closeWallet': '关闭钱包',
  'landing.menu.community': '社区',
  'landing.menu.copyAddress': '复制地址',
  'landing.menu.docs': '文档',
  'landing.menu.exchange': '交易所',
  'landing.menu.explorer': '浏览器',
  'landing.menu.orders': '订单',
  'landing.menu.orders.feeHistory': '手续费历史',
  'landing.menu.orders.openOrders': '当前委托',
  'landing.menu.orders.orderHistory': '委托历史',
  'landing.menu.orders.tradeHistory': '历史成交',
  'landing.menu.testnet': '测试网',
  'landing.menu.tools': '工具',
  'landing.menu.transaction': '交易',
  'landing.menu.wallet': '钱包',
  'landing.startTrading': '开始交易',
  'landing.trust.activeAddress': '活跃钱包',
  'landing.trust.activeAddress.desc':
    '与任何其他钱包解决方案相比，更多的人相信Binance DEX的基础架构和交易系统。',
  'landing.trust.pairs': '交易对',
  'landing.trust.pairs.desc': 'Binance DEX每周为您提供更多选择和交易灵活性。',
  'landing.trust.rank': '排名',
  'landing.trust.rank.desc': 'Binance DEX是Coinmarketcap上排名第一的去中心化加密货币交易所。',
  'landing.trust.title': '人们为什么信任我们',
  'landing.why.competitive': '竞争力',
  'landing.why.competitive.desc':
    '当您使用BNB支付交易费用时，费用仅为0.04％。 这几乎是全球领先的交易费用交易平台Binance.com的一半。',
  'landing.why.fast': '快',
  'landing.why.fast.desc':
    '区块时间为1秒，区块链交易确认已成为过去。 充分利用DEX的所有优点，而没有缺点。',
  'landing.why.secure': '安全',
  'landing.why.secure.desc':
    'Binance DEX将安全性提升到一个全新的水平。 点对点转移和交易意味着几乎零安全威胁。',
  'landing.why.title': '为什么是币安去中心化交易平台',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': '您没有',
  'openOrders.areYourTrue': '你确定需要',
  'openOrders.cancel': '撤销订单吗',
  'openOrders.cancel all': '撤销全部订单吗',
  'openOrders.cancel buy': '撤销买单吗',
  'openOrders.cancel sell': '撤销卖单吗',
  'openOrders.cancelAll': '撤销全部订单',
  'openOrders.cancelBuy': '撤销买单',
  'openOrders.cancelOrder': '撤销订单',
  'openOrders.cancelOrders': '撤销订单',
  'openOrders.cancelPartialSuccess': '撤销部分订单成功',
  'openOrders.cancelSell': '撤销卖单',
  'openOrders.cancelSuccess': '撤销成功',
  'openOrders.keepOrder': '取消',
  'openOrders.keepOrders': '取消',
  'openOrders.noBuyOpenOrders': '没有买单',
  'openOrders.noOpenOrders': '没有委托单',
  'openOrders.noSellOpenOrders': '没有卖单',
  'openOrders.title': '当前委托',
  'orderForm.amount': '数量',
  'orderForm.avb': 'Avb',
  'orderForm.buy': '买',
  'orderForm.equivalent': 'Equivalent',
  'orderForm.price': '价格',
  'orderForm.sell': '卖',
  'orderForm.total': '总额',
  'orderHistory.openHistory': '委托历史',
  'orderHistory.title': '委托历史',
  'orderHistory.tradeId': 'Trade ID',
  'orderHistory.tradingPrice': '交易价格',
  'orderHistory.tradingTotal': '交易总量',
  'privateKeyModal.backupText': '把下面的助记词备份在纸上，并将其保存在某个秘密和安全的地方。',
  'privateKeyModal.title': '我的私钥',
  'testnet.binanceChainExplorerGuide': 'Binance Chain 浏览器使用指南',
  'testnet.fastAndSecureDesc': '安全高效的去中心化数字资产交易平台',
  'testnet.fundingYourTestnetAccount': '申请 DEX 测试资金',
  'testnet.howToAccessYourWallet': '如何访问 DEX 钱包',
  'testnet.howToCreateAWallet': '如何在 Binance DEX 上创建钱包',
  'testnet.interfaceGuide': '界面向导',
  'testnet.thingsToAvoid': '测试网注意事项',
  'testnet.title': '币安去中心化交易所 (测试网)',
  'token.issueModal.mintable': '是否可增发',
  'token.issueModal.name': '币种全称',
  'token.issueModal.nameErrMsg': 'token的名字不能超过32个字符',
  'token.issueModal.symbol': '币种',
  'token.issueModal.symbolErrMsg': '字符应该是英文+数字并且长度范围是3～8',
  'token.issueModal.title': '发行Token',
  'token.issueModal.totalSupply': '总量',
  'token.issueModal.totalSupplyErrMsg': '发行总数不对',
  'token.listModal.address': '地址',
  'token.listModal.confirm': '确认',
  'token.listModal.initPrice': '初始价格',
  'token.listModal.proposalId': '申请Id',
  'token.listModal.quoteAsset': '币种',
  'token.listModal.title': '上币',
  'token.listModal.tokenName': '币种名称',
  'token.main.burn': '销毁',
  'token.main.freeze': '冻结',
  'token.main.issueToken': '发行Token',
  'token.main.list': '上币',
  'token.main.listSuccessmsg': '上币成功',
  'token.main.mint': '增发',
  'token.main.proposal': '申请上币',
  'token.main.submitListFirst': '请先提交上币申请',
  'token.main.submitSuccessmsg': '提交上币申请成功',
  'token.main.title': '币列表',
  'token.main.unfreeze': '解冻',
  'token.proposalModal.address': '地址',
  'token.proposalModal.baseAsset': '基本币种',
  'token.proposalModal.desc': '描述',
  'token.proposalModal.expireTime': '过期时间',
  'token.proposalModal.hours': '小时',
  'token.proposalModal.initDeposit': '初始储备金',
  'token.proposalModal.initPrice': '初始价格',
  'token.proposalModal.initPriceErr': '初始价格不能为空',
  'token.proposalModal.initPriceErr2': '初始价格应该大于0',
  'token.proposalModal.quoteAsset': 'Quote 币种',
  'token.proposalModal.title': '上币申请',
  'token.proposalModal.titleErr': '申请的标题不能为空',
  'token.proposalModal.titleErr2': '申请标题长度不能超过128',
  'token.proposalModal.votingPeriod': '投票时间',
  'token.table.col.mintable': '是否可增发',
  'token.table.col.name': '名称',
  'token.table.col.symbol': '币种',
  'token.table.col.totalSupply': '总量',
  'token.tokenModal.address': '地址',
  'token.tokenModal.amount': '数量',
  'token.tokenModal.available': '可用余额',
  'token.tokenModal.burnTitle': '销毁币种',
  'token.tokenModal.confirm': '确认',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': '冻结 Token',
  'token.tokenModal.mintTitle': '增发',
  'token.tokenModal.name': '名称',
  'token.tokenModal.unfreezeTitle': '解冻Token',
  'token.warning':
    '我们目前不支持与walletconnect兼容的钱包，并且出于安全原因，Ledger是发币/上币/增发/销毁Token的最佳选择',
  'tradeHistory.tradeHistory': '历史成交',
  'transaction.here': '这里',
  'transaction.notes': '并非每笔交易都包含在下面。 有关完整的历史记录，请参阅',
  'txHistory.here': '这儿',
  'txHistory.notEveryTransactionIsIncludedBelow':
    '不是每一条交易信息都会在这里显示。如需查看全部历史记录，请点击查阅。',
  'txHistory.title': '交易记录',
  'unlock.connectAddress.enterYourAddress': 'Enter your address',
  'unlock.connectAddress.invalidAddress': '无效的地址',
  'unlock.connectAddress.viewOnlyMode': 'Enter an address for view only mode',
  'unlock.createNewWallet': '创建一个新钱包',
  'unlock.google.chooseWallet': '请选择您的一个钱包',
  'unlock.google.logIn': '登录',
  'unlock.google.notLoggedIn': '您还没登录您的Google账户',
  'unlock.google.signedInAs': '登陆成功',
  'unlock.googledrive.editWallet': '编辑钱包',
  'unlock.googledrive.wallets': '请从下面的钱包中选择',
  'unlock.index.selectUnlockType': '请选择您解锁的方式',
  'unlock.index.title': '解锁钱包',
  'unlock.keystore.enterYourWalletPass': '输入一个强密码',
  'unlock.keystore.paste': '或者复制您的Keystore 文件内容',
  'unlock.keystore.select': '连接加密的钱包文件并输入密码',
  'unlock.keystore.upload': '上传您的Keystore文件',
  'unlock.ledger.appInstallation': '安装App',
  'unlock.ledger.binanceChainReady': '请准备好 Binance Chain',
  'unlock.ledger.connectToLedger': '连接Ledger硬件钱包',
  'unlock.ledger.enterPINCode': '输入PIN密码',
  'unlock.ledger.getTheApp': '获取应用程序',
  'unlock.ledger.havingConnectionIssues': '连接出错?',
  'unlock.ledger.mustBeOnScreen': '在 Ledger 钱包中',
  'unlock.ledger.openBinanceChain': '打开币安链',
  'unlock.ledger.text': '按照屏幕上的说明在此处连接硬件钱包',
  'unlock.ledger.title': '用Ledger解锁',
  'unlock.ledger.usageInstructions': '使用说明',
  'unlock.mnemonic.pleaseEnterYourPhrase': '请输入您的24个助记词',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': '请问空格隔开每一个助记词。',
  'unlock.mnemonic.warning.desc1': '该选项恢复丢失的KeyStore 文件、密码',
  'unlock.mnemonic.warning.desc2': '或者从其他钱包导入助记词',
  'unlock.mnemonic.warning.desc3':
    '警告提醒：请勿在其他任何网站输入您的助记词或者私钥，一旦您的浏览器安装了恶意插件或者不小心访问了钓鱼网站，您的资产可能会有被盗风险。',
  'unlock.privateKey.enterYourPrivateKey': '输入您的私钥（Hex格式）',
  'unlock.privateKey.invalid': '私钥格式错误（无效的私钥）',
  'unlock.privateKey.passwordInvalid': '临时会话密码错误',
  'unlock.privateKey.warning': '用于恢复丢失的Keystore文件或密码',
  'unlock.privateKey.warningQuestion':
    '请勿在网站上显示您的私钥，一旦您的浏览器安装了恶意插件或不小心访问了钓鱼网站，您的资产可能会有被盗风险。',
  'unlock.recover.content': '使用在创建钱包期间已知的恢复短语来恢复钱包访问',
  'unlock.recover.download.button': '下载',
  'unlock.recover.downloadTitle': '下载你的Ketstore文件',
  'unlock.recover.password.placeholder': '输入一个强密码',
  'unlock.recover.submit': '提交',
  'unlock.recover.title': '恢复keystore文件',
  'unlock.recover.understand.continue': '恢复 Keystore 文件',
  'unlock.recover.word.placeholder': '搜索',
  'unlock.recover.wordlist.reset': '重置',
  'unlock.recover.wordlistTitle': '请选择左侧的单词',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': '临时会话密码',
  'unlock.thisIsNotAValidWalletFile': '这是一个无效的钱包文件',
  'unlock.trezor.connectToTrezor': '连接到Trezor',
  'unlock.trezor.firmwareNotice': '提示：为了能在币安链上面使用，请确保Trezor已经更新到最新版本',
  'unlock.trezor.notOnTestNet': '提示：Trezor目前只支持Chrome或者火狐浏览器',
  'unlock.trezor.title': 'Trezor解锁',
  'unlock.unlockWalletNow': '解锁钱包',
  'unlock.walletConnect.notes': '提示:Trust Wallet and CoolWallet 不支持testnet.',
  'unlock.walletConnect.recommendedWallet': '支持的钱包',
  'unlock.walletConnet.getTrustWallet': '下载 Trust Wallet',
  'unlock.walletConnet.qrCodeDesc1': '获取WalletConnect二维码',
  'unlock.walletConnet.qrCodeDesc2': '还没有支持WalletConnect的App？',
  'unlock.walletConnet.showWalletQrCode': '使用屏幕上的二维码连接你的手机钱包',
  'unlock.walletConnet.title': '推荐',
  'walletConnect.clickHereToUnlock': '点击切换其他钱包',
  'walletConnect.error': 'WalletConnect 错误',
  'walletConnect.errorOccur': 'WalletConnect 发生了错误',
  'walletConnect.pleaseEnsureOpenWorking': '请确保你的打开了App',
  'walletConnect.pleaseUseAWalletConnect': '请使用WalletConnect扫描下方的二维码',
  'walletConnect.qrCode': 'WalletConnect 二维码',
  'walletConnect.readyToConfirm': '请确认',
  'walletConnect.readyToConfirmBody': '请在App中确认交易',
  'walletconnect.notifycation.connectAgain': '重新连接',
  'walletconnect.notifycation.disconnectMessage': '已经和手机钱包断开链接...',
  'walletconnect.notifycation.hide': '隐藏',
  'local.secure.storage': '本地安全存储',
  'local.keystore.replace.tips': '您已经有一个密钥库文件，请确保已备份，然后再替换',
}
